import React, { FC } from "react";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ObjectiveProposalFlow, ObjectiveProposalFlowProps } from "./ObjectiveProposalFlow";

// Internal-facing wrapper: opens the wizard in a Dialog (e.g. from the Sales
// admin pages). Callers are authenticated, so no captcha.
interface ProposalFlowModalProps extends Omit<ObjectiveProposalFlowProps, "requireCaptcha"> {
    open: boolean;
    onClose: () => void;
}

export const ProposalFlowModal: FC<ProposalFlowModalProps> = ({ open, onClose, ...flowProps }) => (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <IconButton
            onClick={onClose}
            sx={{ position: "absolute", top: 10, right: 10, zIndex: 1 }}
            aria-label="Close"
        >
            <CloseIcon />
        </IconButton>
        <DialogContent sx={{ p: { xs: 2.5, sm: 4 } }}>
            <ObjectiveProposalFlow {...flowProps} requireCaptcha={false} />
        </DialogContent>
    </Dialog>
);
